import "./name.css";

function NameFolder() {
  return (
    <section className="Name_folder">
      <ul>
        <p>
          Anciennement connue sous le nom de B Contact Azur, elle a été créée en{" "}
          <span className="opacity">2024 </span>
          par <span className="opacity">Grégory KIENER</span>, chef des ventes
          et <span className="opacity">Christopher Poulain</span>, responsable
          technique de l'agence, tous les deux dotés d'une grande expérience
          dans leur domaine.
        </p>
        <p>
          Leur <span className="opacity">professionnalisme</span> et leur
          sérieux, leur ont permis de conserver leurs anciens clients et de
          développer une nouvelle clientèle.
        </p>
        <p>
          Leur disponibilité, leur connaissance approfondie du matériel proposé
          et leur veille technologique maintiennent une{" "}
          <span className="opacity">relation de confiance</span>.
        </p>
        <p>
          Pour tous vos projets, n’hésitez pas à{" "}
          <span className="opacity">
            <a href="#contact">nous contacter</a>
          </span>{" "}
          et nous nous ferons un plaisir de vous accompagner.
        </p>
      </ul>
    </section>
  );
}

export default function Name() {
  return (
    <>
      <NameFolder />
      <section className="Name">
        <div className="name-tag">ALPES-MARITIMES (06) & VAR (83)</div>
        <h2>
          Pourquoi <br /> ce <span className="opacity">nom ?</span>
        </h2>

        <ul>
          <article className="cards">
            <img src="" alt="" />
            <h2>Azurea</h2>
            <p>
              Notre agence est basée sur notre belle côte azuréenne, notre
              volonté est de rester à proximité géographique de vous, pour
              accroître toujours plus notre réactivité technique et commerciale.
            </p>
          </article>
          <article className="cards">
            <img src="" alt="" />
            <h2>Print</h2>
            <p>
              La vente et la location de matériels d’impression et de
              numérisation, est le premier domaine d’activité qui nous a permis
              d’être reconnu dans la région depuis de nombreuses années.
            </p>
          </article>
          <article className="cards">
            <img src="" alt="" />
            <h2>& Solutions</h2>
            <p>
              Nous sommes là pour vous apporter des solutions qui répondent à
              vos problématiques, à vos obligations légales dans nos domaines
              d’expertise et qui optimisent vos tâches professionnelles
              bureautiques.
            </p>
          </article>
        </ul>
      </section>
    </>
  );
}
